<mat-select multiple placeholder="{{'Severity'|i18n}}"
            [value]="severities"
            (selectionChange)="onSelectSeverities($event)">
    <mat-select-trigger>{{'Severity'|i18n}}</mat-select-trigger>
    <mat-option [value]="Severity.NORMAL" [disabled]="!severityEnabled(Severity.NORMAL)" class="mat-primary">
        <div fxLayout="row" fxLayoutAlign="space-between">
            <div>{{Severity.NORMAL|notSeverity|i18n}}</div>
            <div>
                <app-icon class="pl-8 text-accent" [name]="Severity.NORMAL|notSeverityIcon"></app-icon>
            </div>
        </div>
    </mat-option>
    <mat-option [value]="Severity.INFO" [disabled]="!severityEnabled(Severity.INFO)" class="mat-primary">
        <div fxLayout="row" fxLayoutAlign="space-between">
            <div>{{Severity.INFO|notSeverity|i18n}}</div>
            <div>
                <app-icon class="pl-8 text-primary" [name]="Severity.INFO|notSeverityIcon"></app-icon>
            </div>
        </div>
    </mat-option>
    <mat-option [value]="Severity.ALERT" [disabled]="!severityEnabled(Severity.ALERT)" class="mat-primary">
        <div fxLayout="row" fxLayoutAlign="space-between">
            <div>{{Severity.ALERT|notSeverity|i18n}}</div>
            <div>
                <app-icon class="pl-8 text-warning" [name]="Severity.ALERT|notSeverityIcon"></app-icon>
            </div>
        </div>
    </mat-option>
</mat-select>
